import { z } from "zod";
import { Phase1CheckResultV1Schema } from "./phase1-check-result.js";
export const LEAD_PATH_CHECK_ID = "surface-quality.lead-path-reachable";
export const LeadPathCheckResultV1Schema = Phase1CheckResultV1Schema.extend({
    checkId: z.literal(LEAD_PATH_CHECK_ID),
});
export const LeadPathContactInputSchema = z
    .object({
    phone: z.string().optional(),
    email: z.string().optional(),
})
    .strict();
export const LeadPathEvaluatorInputSchema = z
    .object({
    html: z.string(),
    contact: LeadPathContactInputSchema.optional(),
    formConfigured: z.boolean().optional(),
})
    .strict();
//# sourceMappingURL=lead-path-check-result.js.map